<template>
  <div
    id="addendum-detail-content"
    class="detail-summay-containter"
  >
    <tender-head
      ref="tenderEditHead"
      :tenderGeneral="currentTender.general"
    >
      <template v-if="isPicView || isRepresentative">
        <button
          v-if="!isEditing"
          v-note="{text:noteText, enable:!editable}"
          type="button"
          class="btn btn--darkblue"
          :disabled="!editable"
          @click="goEdit()"
        >{{ $t('action.edit') }}</button>
        <template v-else>
          <cancel-addendum v-if="isPicView" />
          <button
            v-hkldreset
            type="button"
            class="btn btn--orange nav-btn-top"
            @click="saveAndToView()"
          >{{ $t('action.preview_save') }}</button>
        </template>
      </template>
    </tender-head>
    <div class="detail-summay-accordion-container">
      <ul
        id="detail-summay-accordion"
        class="accordion accordion-main accordion-customize"
        data-accordion
        data-deep-link="true"
        data-allow-all-closed="true"
        data-multi-expand="true"
        data-update-history="true"
        data-deep-link-smudge="500"
      >
        <li
          class="accordion-item"
          data-accordion-item
        >
          <a
            href="#detail-summary-tabs"
            class="accordion-title"
          >
            <span>{{ $t('summary.name') }}</span>
          </a>
          <div
            id="detail-summary-tabs"
            class="accordion-content"
            data-tab-content
          >
            <div>
              <Addendum :isBid="false" />
            </div>
          </div>
        </li>
        <li
          class="accordion-item is-active"
          data-accordion-item
        >
          <a
            href="#detail-summary-tabs"
            class="accordion-title"
          >
            <span>{{ $t('tender.detail') }}</span>
          </a>
          <div
            id="detail-summary-tabs"
            class="accordion-content detail-summary-tabs"
            data-tab-content
          >
            <div>
              <TenderTabsContainer
                v-if="isEditing"
                :isTender="isTender"
                :tabsInvalid="tabsInvalid"
              >
                <General
                  slot="general"
                  ref="general_tab"
                  :isTender="isTender"
                />
                <ScopeOfWorkEditor slot="scopeOfWork" />
                <ItemsServices
                  slot="itemServices"
                  ref="items_services_tab"
                  :lockItems="lockItems"
                />
                <FileUpload
                  slot="fileUpload"
                  ref="file_uploader_tab"
                  :attachment.sync="attachment"
                  :showTenderHints="true"
                  :metaData="{category: undefined}"
                  :resourceId="currentTender.general.id"
                  :overallDescription="true"
                />
                <TermsConditions
                  slot="termsConditions"
                  :isTender="isTender"
                  :zipName="zipNames.terms"
                  :tenderId="tenderId"
                />
                <template v-if="isPicView || isRepresentative">
                  <cancel-addendum
                    v-if="isPicView"
                    :className="'btn btn--darkblue mini-btn'"
                  />
                  <button
                    v-hkldreset
                    type="button"
                    class="btn btn--orange nav-btn-top mini-btn"
                    @click="saveAndToView()"
                  >{{ $t('action.preview_save') }}</button>
                </template>
              </TenderTabsContainer>

              <TenderTabsContainer
                v-else
                :isTender="isTender"
              >
                <button
                  v-if="isPicView || isRepresentative"
                  v-note="{text:noteText, enable:!editable}"
                  type="button"
                  class="btn btn--darkblue"
                  :disabled="!editable"
                  @click="goEdit()"
                >{{ $t('action.edit') }}</button>
                <GeneralView
                  v-if="tenderId === currentTender.general.id"
                  slot="general"
                />
                <ScopeOfWork slot="scopeOfWork" />
                <ItemsServicesView slot="itemServices" />
                <Attachments
                  slot="fileUpload"
                  :files="attachmentFiles"
                  :description="attachment.description"
                  :zipName="zipNames.attachments"
                />
                <TermsConditions
                  slot="termsConditions"
                  :tenderId="tenderId"
                  :isTender="isTender"
                  :zipName="zipNames.terms"
                />
              </TenderTabsContainer>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div>
      <TenderRepresentative v-show="showTenderRep" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import { saveAttachment } from '@/api/docs/request'
import checkEditableMixin from '@/modules/tenders/checkEditableMixin'
import HTTP from '@/utils/http'
import keepEditStatusMixin from '@/modules/tenders/keepEditStatusMixin'
import mutationTypes from '@/store/mutation-types'

import Addendum from '@/modules/tenders/review/Addendum'
import Attachments from '@/modules/tenders/view/Attachments'
import CancelAddendum from '@/modules/tenders/addendum/CancelAddendum'
import FileUpload from '@/modules/FileUpload'
import General from '@/modules/tenders/edit/General'
import GeneralView from '@/modules/tenders/view/General'
import ItemsServices from '@/modules/tenders/edit/ItemsServices'
import ItemsServicesView from '@/modules/tenders/view/ItemsServices'
import ScopeOfWork from '@/modules/tenders/view/ScopeOfWork'
import ScopeOfWorkEditor from '@/modules/tenders/edit/ScopeOfWork'
import TenderHead from '@/modules/tenders/TenderHead'
import tenderRepShowMixin from '@/modules/tenders/tenderRepShowMixin'
import TenderRepresentative from '@/modules/tenders/view/TenderRepresentative'
import TenderTabsContainer from '@/modules/tenders/TenderTabsContainer'
import TermsConditions from '@/modules/tenders/TermsConditions'
// Edit tabs end

export default {
  components: {
    Addendum,
    Attachments,
    CancelAddendum,
    FileUpload,
    General,
    GeneralView,
    ItemsServices,
    ItemsServicesView,
    ScopeOfWork,
    ScopeOfWorkEditor,
    TenderHead,
    TenderRepresentative,
    TenderTabsContainer,
    TermsConditions,
  },
  mixins: [checkEditableMixin, keepEditStatusMixin, tenderRepShowMixin],
  data () {
    return {
      isEditing: false,
      lockItems: false,
      tenderId: null,
      tabsInvalid: {
        generalInvalid: false,
        sectionInvalid: false,
        termsInvalid: false,
      },
      // TODO @Gino temparily for tabs use, remove after vuex migrated
      attachment: {
        description: '',
        files: [],
      },
      attachmentFiles: [],
    }
  },
  methods: {
    ...mapActions('tenders', [
      'loadTender',
      'validateRoute',
      'saveCurrentTender',
      'loadRecentRevision',
    ]),
    ...mapMutations('tenders', {
      updateTenderPathField: mutationTypes.TENDER_UPDATE_PATH_FIELD,
      clearSectionForReference: mutationTypes.TENDER_CLEAR_SECTION_FOR_REFERENCE,
    }),
    validate () {
      this.tabsInvalid.generalInvalid = this.$refs.general_tab.validate()
      this.tabsInvalid.sectionInvalid = this.$refs.items_services_tab.validate()
      return (!(this.tabsInvalid.generalInvalid || this.tabsInvalid.sectionInvalid))
    },
    goView () {
      const name = this.isEngineer ? 'tenderAddendumDetailsView' : 'tenderAddendumDetailsViewExt'
      this.$router.push({
        name,
        params: {
          isFromSubmit: true,
          id: this.tenderId,
        },
      })
    },
    async goEdit () {
      await this.checkEditable(this.tenderId)
      if (!this.editable) return
      this.isEditing = true
      this.keepEdit(this.tenderId, this.navToEditPage)
    },
    async saveAndToView () {
      if (!this.validate()) {
        return
      }
      // TODO @Gino remove after sub tabs all migrate to vuex
      this.lockItems = true
      this.clearSectionForReference(true)
      await this.$refs.general_tab.saveCocStandardAttachment()
      await saveAttachment(this.attachment)
      this.updateTenderPathField({
        path: ['general', 'attachmentDescription'],
        newValue: this.attachment.description,
      })

      await this.saveCurrentTender()
      this.clearEditingStatus()
      this.goView()
    },
    // TODO @Gino remove after sub tabs all migrate to vuex
    async initAttachments () {
      const attchmentResp = await HTTP.get(`/docs/?src=${this.tenderId}`)
      this.attachmentFiles = attchmentResp.data.data
    },
    navToEditPage () {
      const path = this.$route.path.replace('/edit', '')
      this.$router.replace({
        path: path,
      })
    },
  },
  async mounted () {
    if (!this.summaryAccordion) {
      this.summaryAccordion = new Foundation.Accordion(($('#detail-summay-accordion')))
    }
    this.tenderId = this.$router.currentRoute.params.id
    await this.loadTender(this.tenderId)
    if (!this.validateRoute()) return
    await this.loadRecentRevision({ loadPendingAddendum: true })
    // check edit status
    if (this.isPicView || this.isRepresentative) {
      await this.checkEditable(this.tenderId)
      const enableEditing = this.$router.currentRoute.params.isEditing
      if (this.editable && enableEditing) {
        this.isEditing = true
        this.keepEdit(this.tenderId, this.navToEditPage)
      }
    }

    // TODO @Gino remove after vuex all implemented
    await this.initAttachments()
    this.attachment.description = this.currentTender.general.attachmentDescription || ''
    $('#tender-tabs li a')[0].click()
  },
  destroyed () {
    if (this.summaryAccordion) {
      this.summaryAccordion.destroy()
    }
    // clear keep edit timeout
    this.clearEditingStatus()
  },
  computed: {
    ...mapGetters('tenders', ['currentTender', 'isPicView', 'isRepresentative', 'zipNames']),
    ...mapGetters('user', ['currentUser', 'isEngineer']),
    isTender () {
      return this.currentTender && this.currentTender.general && this.currentTender.general.tenderType === 'TENDER'
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/stickyBtn";
@import '~styles/accordion';

.nav-btn-top {
  vertical-align: top;
}

.detail-summary-tabs {
  border-bottom: none !important;
}
</style>

<style lang="scss">
#addendum-detail-content {
  .create-tender-main {
    background: #ffffff;
    padding: 0;
  }
}
</style>
